import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';

import Node from '../../common/Node';
import Search from '../../common/Search';
import Loader from '../../common/Loader';
import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';

import { Grid, Button } from '@mui/material';

import { getUrlParameter } from '../../utils';

const styles = {
  title: {
    fontSize: 16,
    marginBottom: '20px',
    display: 'flex',
  },
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '0px 8px',
  },
  createBtn: { marginTop: '46px', padding: '9px 16px', boxShadow: 'none' },
  ...CommonStyles,
};

class CreateNodePage extends ComponentWrapper {
  
  constructor(props) {
    super(props);
    const ako = getUrlParameter('type') === "ako";
    this.state = { ako };
  }
  
  componentDidMount() {
    document.title="Create | Milkyweb";

    const cid = getUrlParameter('cid');
    const { setup } = this.props;
    
    if (cid !== null) {
      this.postWithData({
        url: `/pnkqry3`,
        data: {
          api_key: setup.id,
          filter: {
            nodes: [cid],
          },
        },
        cb: (res) => {
          this.setState({
            ancestor: res.nodes[cid],
            loaded: true,
          });
        },
      });
    } else {
      this.setState({ loaded: true });
    }
  }

  createNode = () => {
    const cid = this.state.ancestor ? this.state.ancestor.id : 0;
    const reqData = {
      cid: this.state.ako ? 0 : cid,
      persist: true,
      nodes:[{ title: this.state.title }],
    };
    this.postWithData({
      url: `/rest/dataimport`,
      data: reqData,
      cb: (data) => {
        if (this.state.ako && cid) {

          this.get({
            url: `/setanc?iid=${data.created_nodes[0]}&cid=${cid}&type=ako`,
            cb: () => {
              document.location.href = `/node/${data.created_nodes[0]}`;
            },
          });

        } else {
          document.location.href = `/node/${data.created_nodes[0]}`;
        }
      }
    });
  }

  render() {
    const { classes } = this.props;
    const { loaded } = this.state;
    
    const conceptElem = this.state.ancestor
        ? <Node
            isLink
            isRemovable
            onRemoveClick={() => {
              this.setState({ ancestor: null });
            }}
            size="md"
            node={this.state.ancestor}
            nodeId={this.state.ancestor.id}
          />
        : <Search
            containerStyles={{
              width: '100%',
              border: '1px solid lightgrey',
              borderTop: '1px solid #BDBDBD',
            }}
            onDropdownElementClick={(params) => {
              this.setState({ ancestor: params.node });
            }}
          />;
     
    return (
      <div>
        <div className={`${classes.subHead} ${classes.mb20}`}>
          Create node | {this.state.ako ? "Subconcept" : "Individual"}
        </div>

        {loaded ? (
          <div className={classes.mainContainer}>
            <Grid container item xs={6} spacing={2}>
              <Grid item xs={5}>
                <div>
                  <span className={classes.title}>Concept:</span>
                  {conceptElem}
                </div>
              </Grid>

              <Grid item xs={5}>
                <div>
                  <span className={classes.title}>Node title:</span>
                  <input
                    onChange={(e) => {
                      this.setState({ title: e.target.value });
                    }}
                    style={{
                      width: '100%',
                      border: '1px solid lightgrey',
                      borderTop: '1px solid #BDBDBD',
                      height: '30px',
                      padding: '5px',
                      fontSize: '16px',
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={1}>
                <Button
                  size="small" 
                  color="primary" 
                  variant="contained" 
                  className={classes.createBtn}
                  onClick={this.createNode}>
                  Create
                </Button>
              </Grid>
            </Grid>
          </div>
        ) : (
          <div className={classes.justifyCenter}>
            <Loader />
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => ({ setup: state.meta.setup }), {})(withStyles(styles)(CreateNodePage));
